import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export type OrbitControlPreset = 'smooth' | 'responsive'

export function createCamera(): THREE.PerspectiveCamera {
  const camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 1000)
  camera.up.set(0, 0, 1)
  camera.position.set(7, 7, 5)
  // Always look at world origin so rotation pivots around (0,0,0)
  camera.lookAt(0, 0, 0)
  return camera
}

export function createControls(
  camera: THREE.PerspectiveCamera,
  canvas: HTMLCanvasElement,
  preset: OrbitControlPreset = 'responsive',
): OrbitControls {
  const controls = new OrbitControls(camera, canvas)
  controls.enableDamping = true
  controls.dampingFactor = preset === 'responsive' ? 0.12 : 0.05
  controls.screenSpacePanning = false
  controls.minDistance = 3
  controls.maxDistance = 25
  // Initialize orbit pivot at coordinate origin; pan will move this target
  controls.target.set(0, 0, 0)
  return controls
}
